export default __webpack_public_path__ + "static/digital-transform-mobile-banner-d69adf77da605e478be7302cea98e901.png";